module.exports = __webpack_public_path__ + "img/SMiG_RGB_150dpi.2253f67e.png";